<template>
  <div class="about chinese_container">
    <myHeader />
    <!-- 创意合作伙伴部分 -->
    <div class="backgro">
      <div class="posi">
        <!-- <img src="https://download.hecoos.com/enlightv/2025-16/132418bbc1795b124de4f4aae0ebcf7a.PNG"
          class="wow fadeInUp" alt="" /> -->
        <div class="posi_Color">
          <span
            v-for="(value, index) in hecoosArray"
            :key="index"
            class="posi_font animate__animated animate__fadeInUp"
            :style="{
              'animation-delay': `${index / 8}s`,
            }"
            ><span class="color">{{ value }}</span></span
          >
        </div>
        <h1 class="posih1">你的创意合作伙伴！</h1>
      </div>
    </div>
    <!-- 第二屏 -->
    <div class="backgro1">
      <div>
        <div class="posi">
          <p class="wow fadeInUp" style="margin-bottom: 50px">
            全球领先的全域制作平台，凭借视频播控、灯光预编程、互动体验、机械控制、虚拟制作等核心能力，为影视虚拟制片、展览演艺、艺术装置、品牌发布会等场景提供全链路数字化解决方案。
          </p>

          <p class="wow fadeInUp">
            目前，hecoos已服务全球1,000+场高规格项目，曾深度参与《2022北京冬奥会开幕式》等国际顶级舞台，以及赋能深圳卫视虚拟拍摄影棚，打造全流程虚拟制播工作流程，持续用技术贯通艺术创意与最终呈现，为创作者带来高效、精准的制作体验，让精彩直达每一帧画面。
          </p>
        </div>
      </div>
    </div>

    <!-- 文化数字化的新引擎 -->
    <div class="backgro2">
      <div>
        <div class="posi">
          <h1 class="posih1 wow fadeInUp ProductTitle">文化数字化的新引擎</h1>
          <p class="posih1 wow fadeInUp">
            北京澜景科技以“文化数字化的新引擎”为公司定位，专注于数字媒体软件与互联网产品的研发，为会展、文旅、传媒、教育等行业提供数字化工具产品，并逐步构建覆盖展演仿真、播控系统、虚拟制作、ERP系统的全链条技术生态。其中，Hirender与hecoos媒体服务器以“北京冬奥会开闭幕式”、“杭州亚运会开闭幕式”以及“大阪世博会”等世界级展演活动执行案例为标杆，持续服务于全球各项大型展演活动；澜精灵ERP系统驱动设备租赁、系统集成与文化运营类企业实现全流程数字化升级；深澜空间作为公司旗下的数字艺术示范空间，聚合艺术家、工程师与文化行业从业者共同探索数字时代的文化新表达。创立发展的10年间，澜景以前沿数字技术为内核，不断用创新推动数字科技与文化产业的共生演进。
          </p>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="clearfix" id="specific-position">
      <div class="clearfix_contain">
        <div class="left">
          <h1 class="title wow fadeInUp ProductTitle">联系我们</h1>
          <p class="description wow fadeInUp">
            请将您的需求发给我们，我们将仔细阅读您的留言，<br>并与您取得联系。
          </p>
          <div
            v-for="(contact, index) in contactInfos"
            :key="index"
            class="contact-item wow fadeInUp"
          >
            <span class="ssssss wow fadeInUp">{{ contact.type }}</span>
            <span class="s1 wow fadeInUp">{{ contact.value }}</span>
          </div>
        </div>
        <!-- 发送留言 -->
        <div class="right">
          <div class="formtest">
            <div class="form-group wow fadeInUp">
              <input
                v-model="formData.name"
                type="text"
                placeholder="你的姓名"
                class="form-input"
              />
            </div>
            <div class="form-group wow fadeInUp">
              <input
                v-model="formData.email"
                type="email"
                placeholder="邮箱地址"
                class="form-input"
              />
            </div>
            <div class="form-group wow fadeInUp">
              <textarea
                v-model="formData.content"
                placeholder="留言"
                class="form-textarea"
              ></textarea>
              <div class="button-container">
                <button class="send-button1 wow fadeInUp" @click="handleSubmit">
                  确认发送
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 5L9 5"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M6 2L9 5L6 8"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加入我们 -->
<!--    <div class="padd">-->
<!--      <div class="job-list-container wow fadeInUp">-->
<!--        <h1 class="wow fadeInUp ProductTitle">加入我们</h1>-->
<!--        <p class="wow fadeInUp" style="margin-bottom: 50px">-->
<!--          欢迎投置简历至:hr@enlightv.com-->
<!--        </p>-->
<!--        <div class="filter-section">-->
<!--          <select v-model="selectedCategory">-->
<!--            <option value="all">全部岗位</option>-->
<!--            &lt;!&ndash; <option value="category1">岗位类别1</option>-->
<!--              <option value="category2">岗位类别2</option> &ndash;&gt;-->
<!--            <option v-for="titleItem in newTiele" :value="titleItem">-->
<!--              {{ titleItem }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <select v-model="selectedCity">-->
<!--            <option value="all">请选择工作城市</option>-->
<!--            <option v-for="cityItem in newCity" :value="cityItem">-->
<!--              {{ cityItem }}-->
<!--            </option>-->
<!--          </select>-->

<!--          <button @click="filterJobs" class="btn1">-->
<!--            <i class="iconfont icon-zaicitijiao"></i>-->
<!--            重置-->
<!--          </button>-->
<!--        </div>-->
<!--        &lt;!&ndash; 标题 &ndash;&gt;-->
<!--        <div class="job-info1">-->
<!--          <span>职位名称</span>-->
<!--          <span>职位类别</span>-->
<!--          <span>工作城市</span>-->
<!--          <span>发布时间</span>-->
<!--        </div>-->
<!--        &lt;!&ndash; 内容 &ndash;&gt;-->
<!--        <div v-if="filteredJobs.length > 0">-->
<!--          <div-->
<!--            v-for="(job, index) in filteredJobs"-->
<!--            :key="index"-->
<!--            class="job-item"-->
<!--          >-->
<!--            &lt;!&ndash; 标题 &ndash;&gt;-->
<!--            <div class="job-info">-->
<!--              <img-->
<!--                src="https://download.hecoos.com/enlightv/2025-16/f8e8a005e173c743b265a666cdd31466.png"-->
<!--                class="ss11"-->
<!--              />-->

<!--              <span class="job-name">{{ job.title }}</span>-->
<!--              <span class="job-category">{{ job.type_name }}</span>-->
<!--              <span class="job-city">{{ job.city }}</span>-->
<!--              <span class="job-time">{{ job.create_time }}</span>-->
<!--              <span-->
<!--                @click="toggleExpand(job.id)"-->
<!--                style="color: #1a90ff"-->
<!--                class="ss"-->
<!--              >-->
<!--                {{ job.isExpanded ? "收起详情" : "查看详情" }}</span-->
<!--              >-->
<!--              <i v-if="job.isExpanded" class="el-icon-arrow-up ss1"></i>-->
<!--              <i v-else class="el-icon-arrow-down ss1"></i>-->
<!--            </div>-->
<!--            &lt;!&ndash; 详情 &ndash;&gt;-->
<!--            <div v-show="job.isExpanded" class="job-details">-->
<!--              <h2>-->
<!--                欢迎投递简历至:-->
<!--                <span style="color: #1990ff">hr@enlightv.com</span>-->
<!--              </h2>-->
<!--              <h3>岗位职责：</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.duty"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>任职要求：</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.condition"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>福利待遇：</h3>-->
<!--              <div v-html="job.welfare" class="job_hole"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 无内容显示 &ndash;&gt;-->
<!--        <div v-else class="no_data">暂无岗位</div>-->
<!--      </div>-->
<!--    </div>-->

    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader";
import myFooter from "@/components/pc/myFooter";
import BackToTop from "@/components/pc/BackToTop";
import { getJobList, getContactUs } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      hecoosArray: ["h", "e", "c", "o", "o", "s"],
      isShow: false,
      jobs: [],
      newTiele: [],
      newCity: [],
      formData: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
      contactInfos: [
        { type: "邮箱", value: "info@enlightv.com" },
        { type: "咨询热线", value: "400-600-1196（7x24小时）" },
        { type: "公司直机", value: "010-53608556（工作日 9:00-18:00）" },
        { type: "QQ交流群", value: "794369725" },
        { type: "微信咨询", value: "hecoos_studio" },
      ],
      selectedCategory: "all",
      selectedCity: "all",
      // selectedTime: "",
    };
  },
  mounted() {},
  computed: {
    filteredJobs() {
      // console.log(this.filteredJobs);

      return this.jobs.filter((job) => {
        const categoryMatch =
          this.selectedCategory === "all" ||
          job.title === this.selectedCategory;
        const cityMatch =
          this.selectedCity === "all" || job.city === this.selectedCity;
        return categoryMatch && cityMatch;
      });
    },
  },
  created() {
    this.getJobInfo();
  },
  methods: {
    filterJobs() {
      this.selectedCategory = "all";
      this.selectedCity = "all";
      // this.selectedTime = "";
    },
    toggleExpand(jobId) {
      const job = this.jobs.find((item) => item.id === jobId);
      if (job) {
        job.isExpanded = !job.isExpanded;
      }
    },
    // 提交联系我们信息
    handleSubmit() {
      if (!this.formData.name) {
        Message.error("请输入你的姓名");
        return;
      }
      // 新增对 email 格式的校验
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.email) {
        Message.error("请输入邮箱地址");
        return;
      } else if (!emailRegex.test(this.formData.email)) {
        Message.error("请输入有效的邮箱地址");
        return;
      }
      if (!this.formData.content) {
        Message.error("请输入留言内容");
        return;
      }

      let postData = {
        ...this.formData,
      };
      getContactUs(postData).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          Message.success(res.message);
          this.formData = {};
        } else {
          Message.error(res.message);
        }
      });
    },
    // 获取招聘信息
    getJobInfo() {
      let postData = {
        limit: "10",
      };
      getJobList(postData).then((res) => {
        this.jobs = res.data;
        // 使用 forEach 遍历 jobs 数组并添加 isExpanded 属性
        this.jobs.forEach((job) => {
          this.$set(job, "isExpanded", false);
        });
        console.log(this.jobs);

        this.newTiele = this.jobs
          .map((item) => item.title)
          .filter((title, index, array) => {
            return array.indexOf(title) === index;
          });
        this.newCity = this.jobs
          .map((item) => item.city)
          .filter((city, index, array) => {
            return array.indexOf(city) === index;
          });
        // console.log(this.newCity);
      });
    },
  },
  components: { myHeader, myFooter, BackToTop },
};
</script>

<style scoped lang="scss">
@import "@/styles/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.darkened-image {
  filter: brightness(0.7);
  /* 可以调整数值来控制暗度，数值越小越暗 */
}
.posi_Color {
  .posi_font {
    .color {
      font-size: 200px !important;
      font-weight: bold !important;
      --k: 0;
      place-self: center;
      background: linear-gradient(
        180deg,
        hsl(calc(var(--k) * 1turn), 95%, 65%),
        hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
      );
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      // font: 900 clamp(0.875em, 7.25vw, 5em);
      text-align: center;
      /* text-transform: uppercase; */
      animation: k 10s linear infinite;
      font-family: "思源黑体Medium";
    }
  }
}
</style>
<style>
.about .job-item .job_hole {
  color: #fff !important;
}

.about .job-item .job_hole p {
  font-size: 14px !important;
  color: #fff !important;
  font-family: YourFontName4 !important;
  line-height: 22px !important;
}

.about .job-item .job_hole span {
  color: #fff !important;
  font-size: 14px !important;
  font-family: YourFontName4 !important;
  line-height: 22px !important;
}

.clear_she {
  width: 20px !important;
}

select::select-arrow {
  width: 10px;
  /* 修改箭头宽度 */
  height: 1000px;
  /* 修改箭头高度 */
}

.flowing-gradient-text {
  font-size: 200px !important;
  --k: 0;
  place-self: center;
  background: linear-gradient(
    90deg,
    hsl(calc(var(--k) * 1turn), 95%, 65%),
    hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font: 900 clamp(0.875em, 7.25vw, 5em) arial black, sans-serif;
  text-align: center;
  /* text-transform: uppercase; */
  animation: k 4s linear infinite;
  font-family: "YourFontName";
}
@property --k {
  syntax: "<number>";
  initial-value: 0;
  inherits: false;
}
@keyframes k {
  to {
    --k: 1;
  }
}

@keyframes gradientFlow {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 100% 50%;
  }
}
</style>
